<template>
  <b-carousel
    :id="`carousel-1-${fotoalbum.id}`"
    :interval="8000"
    controls
    fade
    background="#ababab"
    class="fotoalbum-carousel"
  >
    <!-- Text slides with image -->
    <b-carousel-slide v-for="foto in fotoalbum.fotos" :key="foto.titel">
        <template v-slot:img>
          <img
            v-if="foto.image != null"
            :src="`data:${foto.contentType};base64,${foto.image}`"
            height="480"
            class="d-block img-fluid w-100 slider-img"
          >
          <div v-else class="text-center downloadHeight pt-5">
            <b-spinner type="grow" variant="danger" class="mt-5" ></b-spinner>
          </div>
        </template>
    </b-carousel-slide>
  </b-carousel>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ImageSlieder',
  props: ['fotoalbum'],
  methods: {
    ...mapActions(['getFotoalbumBild']),
    downloadImages () {
      this.fotoalbum.fotos.forEach(foto => {
        if(foto.contentType == null || foto.image == null) {
          const data = {
            fotoalbumId: this.fotoalbum.id,
            filename: foto.titel
          }

          this.getFotoalbumBild(data)
        }
      })
    }
  },
  mounted () {
    this.downloadImages()
  }
}
</script>

<style scoped>
.slider-img {
  height: 40rem;
  width: auto;
  object-fit: contain;
}

.downloadHeight {
  height: 480px;
}
</style>